import { Card } from "@nutrayan/ui";

export function StubPage({ title }: { title: string }) {
  return (
    <div className="space-y-4">
      <h1 className="font-display text-display-xl text-charcoal">{title}</h1>
      <Card>
        <p className="text-body text-ink">
          This screen is wired into the shell. Concrete UI lands as Phase-1 admin tasks (A1-015
          onwards) progress.
        </p>
      </Card>
    </div>
  );
}
